import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "./footer.module.css";
import discordLogo from "../assets/discord-white-logo.png";
import facebookLogo from "../assets/facebook-app-round-white-icon.png";
import linkedinLogo from "../assets/linkedin-app-white-icon.png";
import youtubeLogo from "../assets/youtube-app-white-icon.png";
import instagramLogo from "../assets/instagram-white-logo.png";

export default function Footer() {
  // Some pages have their own colour (Branch is blue, About Us is near-black), so the links
  // strip and the page colour under it follow the page.
  const path = useLocation().pathname;
  const theme = path.indexOf("/branch") === 0 ? "blue" : path.indexOf("/about") === 0 ? "ink" : null;

  useEffect(() => {
    if (!theme) return;
    const previous = document.body.style.backgroundColor;
    document.body.style.backgroundColor = theme === "blue" ? "var(--brand-blue)" : "#06080d";
    return () => {
      document.body.style.backgroundColor = previous;
    };
  }, [theme]);

  const images = [
    {
      src: discordLogo,
      alt: "Discord Logo",
      href: "https://discord.gg/TZYaZKYYTx",
    },
    {
      src: facebookLogo,
      alt: "Facebook Logo",
      href: "https://www.facebook.com/IEEEUTD/",
    },
    {
      src: linkedinLogo,
      alt: "LinkedIn Logo",
      href: "https://www.linkedin.com/company/ieee-utdallas/posts/?feedView=all",
    },
    {
      src: youtubeLogo,
      alt: "YouTube Logo",
      href: "https://www.youtube.com/channel/UCvJGaNTtvCTX8kcpKVgo9rQ",
    },
    {
      src: instagramLogo,
      alt: "Instagram Logo",
      href: "https://www.instagram.com/ieeeutd/",
    },
  ];

  /*


  <h1>Sign Up for Our Newsletter to Receive IEEE Updates.</h1>
        <p className={styles["join"]}>
          Join our IEEE UTD newsletter to stay updated on the latest events,
          workshops, and networking opportunities.
        </p>
        <div className={styles["news-letter"]}>
          <input
            className={styles["news-letter-input"]}
            type="email"
            name="email"
            autoComplete="off"
            placeholder="user@domain.com"
          ></input>
          <button className={styles["subscribe-button"]}>
            subscribe
          </button>
        </div>

  */
  return (
    <footer>
      <div
        className={`${styles["footer"]} ${
          theme === "blue" ? styles.footerBlue : theme === "ink" ? styles.footerInk : ""
        }`}
      >
        <ul className={styles.ul}>
          {images.map((image, index) => (
            <li key={index}>
              <a href={image.href} target="_blank" rel="noreferrer">
                <img
                  key={index}
                  src={image.src}
                  alt={image.alt}
                  className={styles.socialLogos}
                />
              </a>
            </li>
          ))}
        </ul>
        <div className={styles.copyright}>
          Copyright © {new Date().getFullYear()} IEEE at the University of Texas
          at Dallas - All rights reserved
        </div>
      </div>
    </footer>
  );
}
